import StringUtils from "src/utils/stringUtils";

export function generatePieChartData(items: Map<string, number> | undefined, totalCli: number) {
  if (totalCli === 0) {
    return [];
  } else {
    if (items) {
      // Convert the map entries to an array and iterate over them
      return Object.entries(items).map(([label, value]) => ({
        title: convertCamelCaseToTitleCase(label),
        percentage: calculatePercentage(value, totalCli),
        value: value,
      }));
    } else {
      return [];
    }
  }

}

function calculatePercentage(value: number | undefined, total: number): number {
  if (value !== undefined) {
    return (value / total) * 100;
  }
  return 0;
}

export function convertCamelCaseToTitleCase(input: string): string {
  switch (input) {
    case 'failed':
    case 'success':
    case 'ZeroVariance':
      return StringUtils.convertCamelCaseToTitleCase(input);
    case 'Apttus data Missing':
      return 'Apttus Data Missing';
    default:
      return input;
  }
}

export const CREATE_TICKET_URL = 'https://t.corp.amazon.com/create';

const REASON_CODE_DESCRIPTIONS: Record<string, string> = {
  'REPORT_GENERATION_ERROR': 'A technical issue occurred during report generation.',
  'GL_SERVICE_FAILURE': 'A technical issue occurred during report generation.',
  'SQS_PUBLISH_FAILURE': 'A technical issue occurred during report generation.',
  'TP_CHARGE_DATA_NOT_FOUND': 'A technical issue occurred during report generation.',
  'APTTUS_DATA_MISSING': 'Required Apttus data is missing for this CLI. Verify the CLI configuration in Apttus.',
  'TIMEOUT': 'A technical issue occurred during report generation.',
  'PLI Config Missing': 'PLI Step 6 is not configured for this CLI. This is a business configuration issue.',
  'Apttus data Missing': 'Required Apttus data is missing for this CLI. Verify the CLI configuration in Apttus.',
};

// All technical reason codes map to a single user-friendly label
const TECHNICAL_REASON_CODES = [
  'REPORT_GENERATION_ERROR', 'GL_SERVICE_FAILURE', 'SQS_PUBLISH_FAILURE',
  'TP_CHARGE_DATA_NOT_FOUND', 'TIMEOUT',
];


export function getReasonCodeDescription(reasonCode: string): string {
  return REASON_CODE_DESCRIPTIONS[reasonCode] || reasonCode;
}

export function getDisplayReasonCode(reasonCode: string): string {
  if (TECHNICAL_REASON_CODES.includes(reasonCode)) return 'Technical Issue';
  if (reasonCode === 'PLI Config Missing' || reasonCode === 'Apttus data Missing') return reasonCode;
  return reasonCode.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
}

